module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('section', {
    staticClass: "data-cont"
  }, [_c('h3', {
    staticClass: "fx fx-x-between fx-y-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "fx fx-wrap m-l-10"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "选择日期范围(默认所有)",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.handleInit
    },
    model: {
      value: (_vm.params.orderTime),
      callback: function($$v) {
        _vm.$set(_vm.params, "orderTime", $$v)
      },
      expression: "params.orderTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "member-cont"
  }, [_c('div', {
    staticClass: "member-data"
  }, [_c('ul', {
    staticClass: "fx text-center"
  }, [_c('li', {
    staticClass: "fx-fill"
  }, [_c('strong', [_vm._v(_vm._s(_vm.result.get_count))]), _vm._v(" "), _c('p', [_vm._v("领取人数（单位/人）")])]), _vm._v(" "), _c('li', {
    staticClass: "fx-fill"
  }, [_c('strong', [_vm._v(_vm._s(_vm.result.use_person_count))]), _vm._v(" "), _c('p', [_vm._v("使用人数（单位/人）")])]), _vm._v(" "), _c('li', {
    staticClass: "fx-fill"
  }, [_c('strong', [_vm._v(_vm._s(_vm.result.use_count))]), _vm._v(" "), _c('p', [_vm._v("使用次数（单位/次）")])]), _vm._v(" "), _c('li', {
    staticClass: "fx-fill"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("filterMoney")(_vm.result.fee)))]), _vm._v(" "), _c('p', [_vm._v("优惠金额（单位/元）")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("会员卡统计")]), _vm._v(" "), _c('div', {
    staticClass: "question-cont"
  }, [_c('i', {
    staticClass: "icon-question "
  }), _vm._v(" "), _c('div', {
    staticClass: "question-explain"
  }, [_c('h5', [_vm._v("领取人数")]), _vm._v(" "), _c('p', [_vm._v("领取了会员卡的用户人数")]), _vm._v(" "), _c('h5', [_vm._v("使用人数")]), _vm._v(" "), _c('p', [_vm._v("使用了会员卡的总人数")]), _vm._v(" "), _c('h5', [_vm._v("使用次数")]), _vm._v(" "), _c('p', [_vm._v("使用会员卡进行付款的总次数")]), _vm._v(" "), _c('h5', [_vm._v("优惠金额")]), _vm._v(" "), _c('p', [_vm._v("通过使用会员卡支付所减少的总金额")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-12235f6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/vip_card/VipStatistics.vue
// module id = 817
// module chunks = 0